import 'slick-carousel';
// import 'selectric';
// import GLightbox from 'glightbox';

const handler = ( $ ) => {
	// disable autocomplete
	$( 'form, input, textarea' )
		.attr( 'autocomplete', 'off' )
		.attr( 'spellcheck', 'false' )
		.attr( 'autocorrect', 'off' );

	// responsive frames
	$( '#content iframe' )
		.not( '.gform_wrapper + iframe' )
		.each( function () {
			const $iframe = $( this );

			if ( ! $iframe.parent().hasClass( 'embed-container' ) ) {
				$iframe.wrap( '<div class="embed-container"></div>' );
			}
		} );

	// responsive tables
	$( 'table' ).wrap( '<div class="responsive-table"></div>' );

	const settings = {
		infinite: true,
		autoplay: true,
		autoplaySpeed: 2000,
		speed: 800,
		pauseOnHover: true,
		mobileFirst: true,
		slidesToShow: 3,
		slidesToScroll: 1,
		dots: false,
		arrows: false,
		responsive: [
			{
				breakpoint: 870,
				settings: 'unslick',
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 5,
				},
			},
		],
	};
	$( '.hero-section .client-logos' ).slick( settings );
	$( window ).on( 'resize', function () {
		if (
			$( window ).width() < 870 &&
			! $( '.hero-section .client-logos' ).hasClass( 'slick-initialized' )
		) {
			$( '.hero-section .client-logos' ).slick( settings );
		}
	} );
};

export default ( ( $ ) => $( handler ) )( jQuery );
